import styled from "styled-components";

export const RightSideBarWrapper = styled.div`
  display: flex;
  flex-grow: 1;
  flex-shrink: 1;
  flex-direction: column;
  height: 100vh;
  background-color: #fff;
  flex-basis: 0;
`;
